module.exports = __webpack_public_path__ + "img/03.bb5bcb0f.jpg";